(() => {
  const HIDDEN_PATTERN = /\{\{?H\}?\}|add-?on/i;      // matches "{{H}}", "{H}", "Add-On", "AddOn"
  const BROKEN_LABEL_PATTERN = /\[hidden\]|\[addon\]/i; // the raw leaked-token pattern you saw in the button

  const fixSelect = (select) => {
    if (select.dataset.ocuFrequencyCleaned === 'true') return;

    const previousSelected = select.options[select.selectedIndex];
    const previousWasSubscription = !!previousSelected && previousSelected.value !== '';
    const previousWasHidden = !!previousSelected &&
      HIDDEN_PATTERN.test(previousSelected.innerText || previousSelected.textContent || '');

    let removedAny = false;
    for (let i = select.options.length - 1; i >= 0; i--) {
      const text = select.options[i].innerText || select.options[i].textContent || '';
      if (HIDDEN_PATTERN.test(text)) {
        select.remove(i);
        removedAny = true;
      }
    }

    if (!removedAny) {
      select.dataset.ocuFrequencyCleaned = 'true';
      return;
    }

    if (select.options.length === 0) {
      select.disabled = true;
      select.dataset.ocuFrequencyCleaned = 'true';
      return;
    }

    if (previousWasHidden && previousWasSubscription) {
      // They were defaulted onto a plan we just hid — keep them on the
      // "upgrade to subscription" path by landing on the next visible
      // subscription plan, instead of falling back to One-time Purchase.
      const nextSubscriptionIndex = Array.from(select.options).findIndex(
        (o) => o.value !== '' && !o.disabled
      );
      if (nextSubscriptionIndex !== -1) {
        select.selectedIndex = nextSubscriptionIndex;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (select.selectedIndex === -1 || select.options[select.selectedIndex]?.disabled) {
      // Edge case: selection became invalid for some other reason — just
      // land on the first enabled option rather than leaving it broken.
      const firstEnabled = Array.from(select.options).findIndex((o) => !o.disabled);
      if (firstEnabled !== -1) {
        select.selectedIndex = firstEnabled;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    select.dataset.ocuFrequencyCleaned = 'true';
  };

  const fixButtonLabel = (wrapper) => {
    const textEl = wrapper.querySelector('.ocu-cart-line-subscription-dropdown__text');
    if (!textEl) return;
    const text = textEl.textContent || '';
    if (BROKEN_LABEL_PATTERN.test(text) || HIDDEN_PATTERN.test(text)) {
      // We don't know the "correct" plan name from here safely, so don't guess a
      // specific frequency — just stop the raw broken/internal string from showing.
      textEl.textContent = 'Upgrade to Subscription';
      wrapper.dataset.ocuLabelPatched = 'true';
    }
  };

  const processWrapper = (wrapper) => {
    const select = wrapper.querySelector('.ocu-cart-line-subscription-dropdown__select');
    if (select) fixSelect(select);
    fixButtonLabel(wrapper);
  };

  const scan = (root = document) => {
    root.querySelectorAll('.ocu-cart-line-subscription-dropdown__wrapper').forEach(processWrapper);
  };

  scan();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.ocu-cart-line-subscription-dropdown__wrapper')) {
          processWrapper(node);
        } else {
          scan(node);
        }
      });
      // Also catch cases where Vue re-renders text/options inside an
      // already-present wrapper (attribute/characterData-level changes)
      if (mutation.target?.closest?.('.ocu-cart-line-subscription-dropdown__wrapper')) {
        const wrapper = mutation.target.closest('.ocu-cart-line-subscription-dropdown__wrapper');
        processWrapper(wrapper);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();